import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/NewsQuiz.css';

const NewsQuiz = () => {
  return (
    <>
      <Helmet>
        <title>News Quiz - Test Your Business Knowledge | Redbox Global</title>
        <meta name="description" content="Test your knowledge of current business events with Redbox Global's weekly news quiz. Challenge yourself on markets, economics, technology, and global affairs." />
        <meta name="keywords" content="news quiz, business quiz, current events quiz, market knowledge test, business trivia, weekly quiz, news challenge, business knowledge" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/news-quiz" />
        <meta property="og:title" content="News Quiz - Test Your Business Knowledge | Redbox Global" />
        <meta property="og:description" content="Test your knowledge of current business events with our weekly news quiz." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/news-quiz" />
        <meta name="twitter:title" content="News Quiz - Test Your Business Knowledge | Redbox Global" />
        <meta name="twitter:description" content="Test your knowledge of current business events with our weekly news quiz." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/news-quiz" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>News Quiz</h1>
          <p className="page-subtitle">Challenge yourself on the week's biggest business stories</p>
        </div>
        
        <div className="page-content">
          <a href="/article/weekly-news-quiz-feb-5" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?w=1200&h=600&fit=crop" alt="News quiz" />
              </div>
              <div className="featured-content">
              
                <h2>Weekly News Quiz: February 5, 2026</h2>
                <p>How closely have you been following this week's business news? Test your knowledge on the Federal Reserve's latest decision, major tech earnings, international trade developments, and the stories that moved markets. 10 questions covering markets, tech, economics, and global business. Can you score a perfect 10/10?</p>
                <span className="article-meta">10 Questions • 5 Minutes • All Levels</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/markets-quiz-january" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=400&fit=crop" alt="Markets quiz" />
                </div>
                <div className="article-content">
                 
                  <h2>January Markets Recap Quiz</h2>
                  <p>Test your knowledge of January's biggest market moves, earnings surprises, and trading trends.</p>
                  <span className="article-meta">12 Questions • Intermediate</span>
                </div>
              </article>
            </a>

            <a href="/article/tech-titans-quiz" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&h=400&fit=crop" alt="Tech quiz" />
                </div>
                <div className="article-content">
                  
                  <h2>Tech Titans Knowledge Challenge</h2>
                  <p>How well do you know the leaders and innovations of the biggest tech companies?</p>
                  <span className="article-meta">15 Questions • Advanced</span>
                </div>
              </article>
            </a>

            <a href="/article/economics-fundamentals-quiz" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&h=400&fit=crop" alt="Economics quiz" />
                </div>
                <div className="article-content">
                  
                  <h2>Economics Fundamentals Quiz</h2>
                  <p>Test your understanding of key economic concepts, indicators, and policy decisions.</p>
                  <span className="article-meta">20 Questions • All Levels</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsQuiz;
